import * as _ from 'lodash';
import { Action, combineActions, createAction, handleAction } from 'redux-actions';
import { API } from '@config/index';
import { Dispatch } from 'redux';

export interface LoginParamsInfo {
  phone: {
    code: string;
    phone: string;
  };
  password: string;
}

export interface StateInfo {
  phone: string;
  password: string;
  error: string;
  loading: boolean;
}

export type PayloadInfo = { [K in keyof StateInfo]: StateInfo[K] };

export const defaultState: PayloadInfo = {
  phone: '',
  password: '',
  error: '',
  loading: false
};

export const handlePhone = createAction('handle_phone', (phone: string) => ({
  phone
}));

export const handlePassword = createAction(
  'handle_password',
  (password: string) => ({
    password
  })
);

export const handleError = createAction('handle_error', (error: string) => ({
  error
}));

const handleLoading = createAction('handle_loading', (loading: boolean) => ({
  loading
}));

export const userLogin = (params: LoginParamsInfo, callback: Function) => {
  return (dispatch: Dispatch) => {
    dispatch(handleLoading(true));
    API.user
      .userLogin({
        area_code: params.phone.code,
        account: params.phone.phone,
        password: params.password
      })
      .then((res: any) => {
        if (res && callback) {
          callback('', res, res.token);
        }

        dispatch(handleLoading(false));
      })
      .catch((err: any) => {
        callback(err.message ? err.message : '', {}, '');
        dispatch(handleLoading(false));

        throw new Error(err.message);
      });
  };
};

export const reducer = handleAction<StateInfo, PayloadInfo>(
  combineActions(handlePhone, handlePassword, handleError, handleLoading),
  {
    next: (state: StateInfo, { payload, type }: Action<PayloadInfo>) => {
      const res = _.assign({}, _.cloneDeep(state), _.cloneDeep(payload));

      return res;
    },
    throw: (state: StateInfo, action: Action<PayloadInfo>) => {
      return {} as any;
    }
  },
  defaultState
);
